import { ArrowDown, ArrowUp, ChevronsUpDown } from "lucide-react";

import { GamificationSortBy } from "../../../../../@types/gamification";
import { useGamificationFilterActions } from "../../ducks/filter/hooks/actions";
import { useFilterState } from "../../ducks/filter/hooks/filterState";

export function SortableHeader({
  field,
  label,
  className = "",
}: {
  field: GamificationSortBy;
  label: string;
  className?: string;
}) {
  const { updateFilter } = useGamificationFilterActions();
  const filterState = useFilterState();
  const { filters } = filterState || { filters: {} };

  const isActive = filters.sortBy === field;
  const order: "ASC" | "DESC" = isActive
    ? filters.sortOrder ?? "ASC"
    : "ASC";

  const handleClick = () => {

    const nextOrder: "ASC" | "DESC" =
      isActive && order === "ASC" ? "DESC" : "ASC";
    updateFilter({ key: "sortBy", value: field });
    updateFilter({ key: "sortOrder", value: nextOrder });
  };

  const resolveIcon = () => {
    if (!isActive) return ChevronsUpDown;
    return order === "ASC" ? ArrowUp : ArrowDown;
  };
  const Icon = resolveIcon();

  const resolveAriaSort = (): "none" | "ascending" | "descending" => {
    if (!isActive) return "none";
    return order === "ASC" ? "ascending" : "descending";
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={`Ordenar por ${label}`}
      aria-sort={resolveAriaSort()}
      className={`flex items-center gap-1.5 font-medium hover:text-primary ${
        isActive ? "text-primary" : ""
      } ${className}`}
    >
      {label}
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />
    </button>
  );
}
